class NewFeatureInfo extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        LuckyOrangeClient.tagComponent("NewFeatureInfo");

        this.state = {};
    }

    render() {
        const { imagePath, descriptions } = this.props;

        return (
            <div className="newFeatureInfo">
                <div className="imgContainer">
                    <img src={dynamicRequire(imagePath)} alt="New Feature" className="newFeatureImage" />
                </div>
                {descriptions.map((desc, index) => (
                    <p key={index} className="newFeatureDescription">{desc}</p>
                ))}
            </div>
        );
    }
}

module.exports = NewFeatureInfo;




// WEBPACK FOOTER //
// ./modules/components/notifications/new_features/NewFeatureInfo.js